<template>
  <div>
    <div class="movie">
      <div class="title--item skeleton">
        <div class="skeleton-loading"></div>
      </div>
      <div class="cast--item skeleton">
        <div class="skeleton-loading"></div>
      </div>
      <div class="overview--item skeleton">
        <div class="skeleton-loading"></div>
      </div>
      <div class="watch--item skeleton">
        <div class="skeleton-loading"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.movie {
  display: grid;
  grid-template-columns: 1fr;
  justify-content: space-evenly;
  column-gap: 15px;
}

.loading {
  font-size: 2em;
  color: #7797c2;
  position: absolute;
  left: 50%;
}
.skeleton {
  box-shadow: 0 4px 10px 0 rgba(33, 33, 33, 0.15);
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}
.skeleton-loading::before {
  content: "";
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
    to right,
    transparent 0%,
    #8f97a7 50%,
    transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes load {
  from {
    left: -150px;
  }
  to {
    left: 100%;
  }
}
.title--item,
.cast--item,
.overview--item,
.watch--item {
  border-radius: 5px;
  margin-top: 20px;
  background-color: #314c75;
  position: relative;
  display: block;
}

.title--item {
  width: 50%;
  height: 30px;
}

.cast--item {
  width: 50%;
  height: 100px;
}

.overview--item {
  width: 90%;
  height: 130px;
}

.watch--item {
  width: 40%;
  height: 90px;
}

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .movie {
    grid-template-columns: repeat(6, auto);
    justify-content: space-evenly;
    column-gap: 12px;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
  .movie {
    grid-template-columns: repeat(4, auto);
    justify-content: space-evenly;
    column-gap: 15px;
  }
  h3.linea:before {
    width: 85%;

    left: 15%;
  }
}

@media (max-width: 600px) {
  .movie {
    grid-template-columns: repeat(2, auto);
    justify-content: space-evenly;
    column-gap: 15px;
  }
  h3.linea:before {
    width: 70%;

    left: 30%;
  }
}
</style>
